'use client';

import {useCallback, useEffect, useState} from 'react';

export const useKeyPress = (keyName: string, isCapture = false) => {
    const [keyPressed, setKeyPressed] = useState(false);

    const handleKeyUpPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === keyName) {
                setKeyPressed(false);
            }
        },
        [keyName],
    );

    const handleKeyDownPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === keyName) {
                setKeyPressed(true);
            }
        },
        [keyName],
    );

    useEffect(() => {
        /* add the capture option not to collide with react events https://reactjs.org/docs/events.html#supported-events */
        document.addEventListener('keydown', handleKeyDownPress, {
            capture: isCapture,
        });
        document.addEventListener('keyup', handleKeyUpPress, {
            capture: isCapture,
        });

        return () => {
            document.removeEventListener('keydown', handleKeyDownPress, {
                capture: isCapture,
            });
            document.removeEventListener('keyup', handleKeyUpPress, {
                capture: isCapture,
            });
        };
    }, [handleKeyDownPress, handleKeyUpPress, isCapture]);

    return keyPressed;
};
